import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=237af97c&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237af97c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237af97c')) {
      api.createRecord('237af97c', component.options)
    } else {
      api.reload('237af97c', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=237af97c&scoped=true&", function () {
      api.rerender('237af97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BDyNjYizvGHT/JS/comp/Voucher-Unit.vue"
export default component.exports